import CourseCard from "../../components/CourseCard/CourseCard";
import Sidebar from "../../components/Sidebar/Sidebar";
import { Topbar } from "../../components/Topbar/Topbar";
import AssignmentSidebar from "../../components/AssignmentSidebar/AssignmentSidebar";
import Button from "../../components/Button/Button";
import DashboardStatsBanner from "../../components/DashboardStatsBanner/DashboardStatsBanner";
import { useEffect, useState } from "react";
import "./Dashboard.scss";
import { useUser } from "../../context/UserContext";
import { getTeacherDashboardStats } from "../../constants/dashboardStats";
import toast from "react-hot-toast";

const Dashboard = () => {
  const { enrolments, fetchEnrolments, fetchPlatformSummary, platformSummary, user } = useUser();
  const name = `${user?.firstName} ${user?.lastName}`;
  const studentView = user?.type === "student";
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const stats = getTeacherDashboardStats(enrolments.length);

  useEffect(() => {
    const loadDashboard = async () => {
      try {
        await Promise.all([
          fetchEnrolments(),
          studentView ? fetchPlatformSummary() : Promise.resolve(),
        ]);
        setIsLoading(false);
      } catch (err) {
        toast.error("Error loading dashboard. Please seek support.");
        console.error(err);
      }
    };

    loadDashboard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let classesSection = <p>Loading...</p>;

  if (!isLoading) {
    if (enrolments.length === 0) {
      if (studentView) {
        classesSection = <p>You are not enrolled in any question banks yet.</p>;
      } else {
        classesSection = (
          <div>
            <p>You have no classes set up yet.</p>
            <Button text="Add class" />
          </div>
        );
      }
    } else {
      classesSection = (
        <div className="courses-wrapper">
          {enrolments.map((e) => (
            <CourseCard {...e} />
          ))}
        </div>
      );
    }
  }

  return (
    <div className="page-wrapper" id="Dashboard">
      <Sidebar />
      <div className="internal-page-wrapper">
        <Topbar title="Dashboard" />
        <main>
          <div id="main-dashboard">
            <DashboardStatsBanner
              name={name}
              studentView={studentView}
              teacherStats={stats}
              platformSummary={platformSummary ?? undefined}
              enrolments={enrolments}
            />

            <div id="titleWrapper">
              <h2>{studentView ? "Your question banks" : "Your Classes"}</h2>
              {studentView ? undefined : <Button text="Create class" />}
            </div>

            {classesSection}
          </div>

          {
            // Only show assignment sidebar for students. Don't show for teachers.
            studentView && <AssignmentSidebar />
          }
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
